import { NetworkResponse } from "~/app/type/common";
import { requestREST } from "~/client/http/CommonHTTP";
import {
  ILicenseAssignParams,
  ILicenseAssignResponse,
  ILicenseRevokeParams,
  ILicenseRevokeResponse,
  ILicensesEmployeesResponse,
  ILicensesOrganizationsResponse,
  ILicensesOverviewParams,
  ILicensesPositionsResponse,
} from "~/entity/Licenses/model/schema";
import { paramsSerializer } from "~/shared/lib/paramsSerializer";

const licensesServiceMap = {
  licenses: "/licenses",
  assign: "/licenses/assign",
  revoke: "/licenses/revoke",
};

const getLicenses = <T>(params?: ILicensesOverviewParams): NetworkResponse<T> =>
  requestREST.get(licensesServiceMap.licenses, {
    params,
    paramsSerializer: (query) => paramsSerializer(query, { skipNulls: true }),
  });

export class LicensesService {
  static _routes = licensesServiceMap;

  static GET = {
    organizations: (
      params?: ILicensesOverviewParams,
    ): NetworkResponse<ILicensesOrganizationsResponse> => getLicenses(params),

    positionGroups: (
      params?: ILicensesOverviewParams,
    ): NetworkResponse<ILicensesPositionsResponse> => getLicenses(params),

    employees: (
      params?: ILicensesOverviewParams,
    ): NetworkResponse<ILicensesEmployeesResponse> => getLicenses(params),
  };

  static POST = {
    assign: (
      data: ILicenseAssignParams,
    ): NetworkResponse<ILicenseAssignResponse> =>
      requestREST.post(licensesServiceMap.assign, data),

    revoke: (
      data: ILicenseRevokeParams,
    ): NetworkResponse<ILicenseRevokeResponse> =>
      requestREST.post(licensesServiceMap.revoke, data),
  };
}
